module.exports = __webpack_public_path__ + "static/media/YF16_6.8822a85d.jpg";